import { toPng } from "html-to-image";

type AnchorLike = {
  click: () => void;
  download: string;
  href: string;
  remove: () => void;
};

type DocumentLike = {
  body: {
    append: (...nodes: AnchorLike[]) => void;
  };
  createElement: (tagName: string) => AnchorLike;
};

export const downloadElementAsPng = async (
  element: HTMLElement,
  filename: string,
  documentRef: DocumentLike = document as unknown as DocumentLike,
): Promise<void> => {
  const width = Math.max(Math.ceil(element.clientWidth), 800);
  const height = Math.max(Math.ceil(element.clientHeight), 400);
  const pngUrl = await toPng(element, {
    backgroundColor: "#fcfcfc",
    cacheBust: true,
    canvasWidth: width * 2,
    canvasHeight: height * 2,
    pixelRatio: 2,
    width,
    height,
  });

  const anchor = documentRef.createElement("a");
  anchor.href = pngUrl;
  anchor.download = filename;
  documentRef.body.append(anchor);
  anchor.click();
  anchor.remove();
};
